export const environment = {
    production: true,
    apiUrl: "https://sdmsservice.stechto.com/"

};
